/* eslint-disable no-restricted-globals */

import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$http', '$scope', 'Util', '$rootScope'];
class DwmToggleMonitoring {

    constructor($http, $scope, Util, $rootScope) {

        const aviraToken = Util.getToken();

        $scope.disableMonitoring = () => {

            $scope.activateLicensePending = true;

            Mixpanel.send('ConnectWeb Modal Button Click', {
                'Button Label': 'Deactivate',
                Modal: 'AIA Monitoring',
            });

            $http({
                method: 'DELETE',
                url: CWCONFIG.dwm.enrollURL,
                headers: {
                    Authorization: `Bearer ${aviraToken}`,
                },
                data: {
                    clientApplication: {
                        clientId: 'myavira',
                    },
                },

            }).then(() => {

                $scope.activateLicensePending = false;
                Util.closeModal();
                $rootScope.aiaStatusApiCall('triggerPendingState');

            }).catch((errResponse) => {

                $scope.activateLicensePending = false;
                Alert.error(
                    { message: 'cw.recommendation.error.connection_failed' },
                    {
                        message: {
                            brandname: CWCONFIG.partnerConfig.name,
                            url: '/dashboard/support/tabs/support',
                        },
                    },
                );

                Mixpanel.send('ConnectWeb AIA Error', {
                    Detail: 'deactivate',
                    ErrorCode: errResponse.data ? errResponse.data.errorCode : 'N/A',
                    ErrorMessage: errResponse.data ? errResponse.data.message : 'N/A',
                    ErrorDescription: errResponse.data ? errResponse.data.error_description : 'N/A',
                    ErrorTrackId: errResponse.data ? errResponse.data.trackId : 'N/A',
                    ErrorStatus: errResponse.data ? errResponse.data.status : 'N/A',
                });

            });

        };

        $scope.cancel = () => {

            Mixpanel.send('ConnectWeb Modal Button Click', {
                'Button Label': 'Cancel',
                Modal: 'AIA Monitoring',
            });

            Util.closeModal();

        };

    }

}

_serviceDependencies.push(DwmToggleMonitoring);

angular.module('controllers')
    .controller('DwmToggleMonitoring', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/toggle-monitoring/toggle-monitoring.js